<template>
    <sa-page-layout :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaAssociazione">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Tipo Impegnativa</label>
                        <!-- <b-form-input v-model="filtroImpegnativaGruppoPrestazioni.impegnativaTipo" type="search" id="codice"></b-form-input> -->
                        <b-form-select v-model="filtroImpegnativaGruppoPrestazioni.codiceFlussoImpegnativa" :options="impegnativaTipoOptions" :value="null" value-field="codiceFlusso" text-field="tipo">
                <template #first>
              <b-form-select-option :value="null" disabled>
                -- Seleziona --
              </b-form-select-option>
            </template>
            <template v-for="item in impegnativaTipoOptions">
 <b-form-select-option :value="item.codiceFlusso" :key="item.id" >
    {{ item.tipo }}
              </b-form-select-option>

            </template>                

                        </b-form-select>                    </b-col>
                    <!--        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Prestazione</label>
                        <b-form-input v-model="filtroImpegnativaGruppoPrestazioni.prestazioneNome" type="search" id="codice"></b-form-input>
                    </b-col> -->
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-impegnativa-gruppo-prestazione-list-component ref="cmpImpegnativaGruppoPrestazioneList" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" />
        </template>
    </sa-page-layout>
</template>

<script>
import RsaConfigurazioneImpegnativaGruppoPrestazioneListComponent from "../components/RsaConfigurazioneImpegnativaGruppoPrestazioneListComponent.vue";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: { SaPageLayout, RsaConfigurazioneImpegnativaGruppoPrestazioneListComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "",
            showModalLoading: false,
            btnConfigurazioniVisible: true,
            linkConfigurazioni: "/configurazioni",
            pathResourceTipoImpegnativa: "/rsaimpegnativatipo",
            pathResourceTipoPrestazione: "/rsatipoprestazioni",
            impegnativaTipoOptions: [],
            filtroImpegnativaGruppoPrestazioni: { prestazioneNome: null, codiceFlussoImpegnativa: null },
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroImpegnativaGruppoPrestazioni"]) {
            me.filtroImpegnativaGruppoPrestazioni = JSON.parse(sessionStorage["filtroImpegnativaGruppoPrestazioni"]);
        }
        me.loadData();
        me.loadTipoImpegnativa();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.cmpImpegnativaGruppoPrestazioneList.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onClickNuovaAssociazione() {
            let me = this;
            me.$refs.cmpImpegnativaGruppoPrestazioneList.nuovaAssociazione();
        },
        onReset() {
            let me = this;
            me.filtroImpegnativaGruppoPrestazioni = { nomeAttivita: null, idDiario: null, idArea: null ,codiceFlussoImpegnativa:null};
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroImpegnativaGruppoPrestazioni"] = JSON.stringify(me.filtroImpegnativaGruppoPrestazioni);

            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroImpegnativaGruppoPrestazioni"] = JSON.stringify(me.filtroImpegnativaGruppoPrestazioni);
            me.loadData();
        },
        loadTipoImpegnativa() {
            let me = this;
            me.loadDataResources(me.pathResourceTipoImpegnativa, {}, me.resultResponseTipoImpegnativa, me.resultErrorTipoImpegnativa);
        },
        resultResponseTipoImpegnativa(response) {
            let me = this;
            me.impegnativaTipoOptions = response.data.data.list
        },
        resultErrorTipoImpegnativa(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore durante il caricamento di Tipo Impegnative";
            me.$bvToast.toast(messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadTipoPrestazioneData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTipoPrestazione, null, me.loadTipoPrestazioneDataSuccess, me.loadTipoPrestazioneDataError);
        },
        loadTipoPrestazioneDataSuccess(response) {
            let me = this;
            /* me.prestazioneOptions = response.data.data.list; */
            if (response.data && response.data.data && response.data.data.list) {
                me.prestazioneOptions = response.data.data.list.map((item) => ({
                    value: item.id,
                    text: item.nome || item.id,
                }));
            } else {
                me.prestazioneOptions = [];
                console.warn("lista prestazione vuota");
            }
            // console.log("prestazioniOptions nel modalEdit: ", this.prestazioneOptions);
        },

        loadTipoPrestazioneDataError(error) {
            console.error("Errore durante il caricamento delle prestazione:", error);
            this.$bvToast.toast("Errore nel caricamento delle prestazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
